import { render, staticRenderFns } from "./BaseRushiSlide.vue?vue&type=template&id=72a93290&scoped=true&"
import script from "./BaseRushiSlide.vue?vue&type=script&lang=js&"
export * from "./BaseRushiSlide.vue?vue&type=script&lang=js&"
import style0 from "./BaseRushiSlide.vue?vue&type=style&index=0&id=72a93290&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a93290",
  null
  
)

export default component.exports